export default __webpack_public_path__ + "static/media/graphic-growthnotes-3x.05cdd557.png";